/**
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

window.showroomChangeCartVariant = async function showroomChangeCartVariant(el) {
  if (!el || el.dataset.changing === '1') return;
  var key = el.dataset.lineKey;
  var qty = Number(el.dataset.lineQty || 1);
  var variantId = Number(el.value);
  if (!key || !variantId) return;

  el.dataset.changing = '1';
  el.disabled = true;
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  var changeUrl =
    (window.theme && window.theme.routes && window.theme.routes.cart_change_url) ||
    '/cart/change.js';
  var addUrl =
    (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ||
    '/cart/add.js';
  var headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  try {
    await fetch(changeUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers,
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    await fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers,
      body: JSON.stringify({ id: variantId, quantity: qty }),
    });
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  } catch (error) {
    console.error(error);
    el.disabled = false;
    el.dataset.changing = '0';
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
};

(function () {
  function setCartCheckoutBusy(busy) {
    document.querySelectorAll('[data-cart-checkout]').forEach(function (el) {
      var isButton = el.tagName === 'BUTTON' || el.tagName === 'INPUT';
      if (isButton) {
        el.disabled = busy;
      } else if (busy) {
        el.setAttribute('aria-disabled', 'true');
        el.setAttribute('tabindex', '-1');
      } else {
        el.removeAttribute('aria-disabled');
        el.removeAttribute('tabindex');
      }
      el.classList.toggle('is-loading', busy);
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.style.pointerEvents = busy ? 'none' : '';
      el.style.opacity = busy ? '0.5' : '';
    });
  }

  document.addEventListener('shapes:cart:lock', function () {
    setCartCheckoutBusy(true);
  });
  document.addEventListener('shapes:cart:unlock', function () {
    setCartCheckoutBusy(false);
  });
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target && event.target.closest && event.target.closest('[data-cart-checkout]');
      if (link && link.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();

window.showroomApplyCartCoupon = async function showroomApplyCartCoupon(form) {
  if (!form) return;
  var input = form.querySelector('[name="discount"]');
  var errorEl = form.querySelector('[data-coupon-error]');
  var button = form.querySelector('[type="submit"]');
  var code = String((input && input.value) || '').trim();
  var emptyMsg = form.getAttribute('data-coupon-empty') || 'Enter a coupon code.';
  var invalidMsg =
    form.getAttribute('data-coupon-invalid') ||
    'This coupon code is invalid or can’t be applied to your cart.';

  function showError(message) {
    if (input) input.classList.add('is-error');
    if (errorEl) {
      errorEl.hidden = false;
      errorEl.textContent = message;
    }
    var details = form.closest('details');
    if (details) details.open = true;
  }

  function clearError() {
    if (input) input.classList.remove('is-error');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function couponApplied(cart) {
    var needle = code.toLowerCase();
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code || '').toLowerCase() === needle) {
        return codes[i].applicable !== false;
      }
    }
    var apps = (cart && (cart.cart_level_discount_applications || cart.discount_applications)) || [];
    for (var j = 0; j < apps.length; j++) {
      var title = String(apps[j].title || apps[j].code || '').toLowerCase();
      if (title === needle || title.indexOf(needle) !== -1) return true;
    }
    return false;
  }

  clearError();
  if (!code) {
    showError(emptyMsg);
    if (input) input.focus();
    return;
  }

  if (button) button.disabled = true;
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    var updateUrl =
      (window.theme && window.theme.routes && window.theme.routes.cart_update_url) ||
      '/cart/update.js';
    var response = await fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
        Accept: 'application/json',
      },
      body: JSON.stringify({ discount: code }),
    });
    var cart = await response.json();
    if (!response.ok || cart.status || !couponApplied(cart)) {
      showError(invalidMsg);
      document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
      return;
    }
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  } catch (error) {
    console.error(error);
    showError(invalidMsg);
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  } finally {
    if (button) button.disabled = false;
  }
};

(function () {
  var clearingNote = false;

  function cartUpdateUrl() {
    return (
      (window.theme && window.theme.routes && window.theme.routes.cart_update_url) ||
      '/cart/update.js'
    );
  }

  function cartHasLeftoverNote(data) {
    if (!data || Number(data.item_count) !== 0) return false;
    return Boolean(String(data.note || '').trim());
  }

  function clearCartNote() {
    if (clearingNote) return;
    clearingNote = true;
    fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
        Accept: 'application/json',
      },
      body: JSON.stringify({ note: '' }),
    }).finally(function () {
      clearingNote = false;
    });
  }

  function maybeClearNote(event) {
    var data = event && event.detail && event.detail.response;
    if (cartHasLeftoverNote(data)) clearCartNote();
  }

  document.addEventListener('shapes:cart:cartqtychange', maybeClearNote);
  document.addEventListener('shapes:cart:update', maybeClearNote);
})();

window.showroomRemoveBundleLines = async function showroomRemoveBundleLines(button) {
  if (!button || button.dataset.removing === '1') return;

  let keys = [];
  try {
    keys = JSON.parse(button.getAttribute('data-line-keys') || '[]');
  } catch (error) {
    keys = (button.getAttribute('data-line-keys') || '')
      .split('|')
      .map((key) => key.trim())
      .filter(Boolean);
  }
  if (!Array.isArray(keys) || !keys.length) return;

  button.dataset.removing = '1';
  button.disabled = true;
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  const updateUrl =
    (window.theme && window.theme.routes && window.theme.routes.cart_update_url) ||
    '/cart/update.js';

  try {
    const inDrawer = Boolean(button.closest('[data-cart-drawer]'));
    const sectionsUrl = inDrawer
      ? (window.theme && window.theme.routes && window.theme.routes.root_url) || '/'
      : window.location.pathname;
    const updates = {};
    keys.forEach((key) => {
      updates[key] = 0;
    });

    const response = await fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
        Accept: 'application/javascript',
      },
      body: JSON.stringify({
        updates,
        sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
        sections_url: sectionsUrl,
      }),
    });
    const data = await response.json();
    const emptyCart = Number(data && data.item_count) === 0;

    if (data.status && !emptyCart) {
      throw new Error(data.description || data.message || 'Could not remove bundle');
    }

    try {
      document.body.dispatchEvent(
        new CustomEvent('shapes:cart:cartqtychange', {
          bubbles: true,
          detail: {
            response: data,
            key: keys[0],
            quantity: 0,
          },
        })
      );
    } catch (error) {
      console.error(error);
    }

    if (!data.sections) {
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
    }
  } catch (error) {
    console.error(error);
    button.disabled = false;
    button.dataset.removing = '0';
    const cartErrors = document.getElementById('cart-errors');
    if (cartErrors) cartErrors.textContent = theme.strings.cartError;
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
};

document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest('[data-remove-bundle-lines]');
    if (!button) return;
    event.preventDefault();
    window.showroomRemoveBundleLines(button);
  },
  true
);

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    const cartErrors = document.getElementById('cart-errors');
    if (cartErrors) cartErrors.textContent = theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
});

/**
 * Browser back/forward can restore this page from bfcache with drawers/menus
 * still open. Close them and refresh cart contents.
 */
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;

  try {
    if (window.Alpine && Alpine.store('modals')?.isRegistered?.('cart')) {
      Alpine.store('modals').close('cart');
    }
    if (window.Alpine && Alpine.store('modals')?.isRegistered?.('nav')) {
      Alpine.store('modals').close('nav');
    }
  } catch (e) {
    console.error(e);
  }

  document.documentElement.classList.remove('showroom-mega-open');
  document.dispatchEvent(new CustomEvent('theme:update:cart'));
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('cart-will-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
});

document.addEventListener('cart-is-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
});

document.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}
